/**
 * @type enum
 */
export enum ConversationInteraction {
	GROWER = 'Grower',
	MULTIPLE_CHOICE = 'MultipleChoice',
}
